import { STATUS_BADGE_VARIANT } from '@/package';
import type { Modeling, WorkProgress } from '@/type';

export enum TASK_WORKSTATE {
  NONE = 'None',
  PENDING = 'Pending',
  READY = 'Ready',
  PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  FAIL = 'Fail',
}

export enum TASK_DISTRIBUTE_METHOD {
  NORMAL = 'Normal',
  BALANCE = 'Balance',
  RANGE = 'Range',
  RATIO = 'Ratio',
}

export const TASK_WORKSTATE_TRANSLATION_MAPPER: {
  [K in TASK_WORKSTATE]: keyof TranslationMap;
} = {
  [TASK_WORKSTATE.NONE]: 'task.noneState.recompound',
  [TASK_WORKSTATE.PENDING]: 'task.pendingState.accomplicity',
  [TASK_WORKSTATE.READY]: 'task.readyState.reindict',
  [TASK_WORKSTATE.PROGRESS]: 'task.progressState.metazoal',
  [TASK_WORKSTATE.COMPLETED]: 'task.completedState.chemicalization',
  [TASK_WORKSTATE.FAIL]: 'task.failState.antipyrine',
} as const;

export enum TASK_FRAME_WORKSTATE {
  WORKING = 'Working',
  PREWORK = 'Prework',
  REVIEW = 'Review',
  REVIEWING = 'Reviewing',
  DONE = 'Done',
  REJECT = 'Reject',
  VIEW_ONLY = 'ViewOnly',
}

export const TASK_FRAME_WORK_STATE_TRANSLATION_KEY_MAPPER = {
  working: 'frame.workingState.fireworm',
  prework: 'frame.preworkState.panegyrizer',
  review: 'frame.reviewState.infeasibleness',
  reviewing: 'frame.reviewingState.preteressential',
  done: 'frame.doneState.hypoendocrinism',
  reject: 'frame.rejectState.swindler',
} as const;
export type TASK_FRAME_STATE_TRANSLATION_KEY_MAPPER_KEY =
  keyof typeof TASK_FRAME_WORK_STATE_TRANSLATION_KEY_MAPPER;

export const STATUS_COLOR_MAP: {
  [key in
    | WorkProgress
    | Modeling['status']
    | Modeling['deployStatus']
    | keyof Pick<
        TranslationMap,
        | 'common.notStarted.disciple'
        | 'common.inProgress.hypopial'
        | 'common.completed.boston'
      >
    | TASK_WORKSTATE
    | STATUS_BADGE_VARIANT]: string;
} = {
  [TASK_WORKSTATE.NONE]: '#B3B3B3',
  [TASK_WORKSTATE.FAIL]: '#F46057',
  [TASK_WORKSTATE.PENDING]: '#B3B3B3',
  [TASK_WORKSTATE.READY]: '#82A8E2',
  [TASK_WORKSTATE.PROGRESS]: '#2CCB6F',
  [TASK_WORKSTATE.COMPLETED]: '#2A58F6',

  [STATUS_BADGE_VARIANT.NOT_STARTED]: '#B3B3B3',
  [STATUS_BADGE_VARIANT.IN_PROGRESS]: '#2CCB6F',
  [STATUS_BADGE_VARIANT.COMPLETED]: '#2A58F6',
  [STATUS_BADGE_VARIANT.FAILED]: '#F46057',
  [STATUS_BADGE_VARIANT.REJECTED]: '#DA645D',
  [STATUS_BADGE_VARIANT.AI_ANNO]: '#7DCC49',
  [STATUS_BADGE_VARIANT.IN_REVIEW]: '#AD55FF',
  [STATUS_BADGE_VARIANT.READY]: '#82A8E2',
  [STATUS_BADGE_VARIANT.SUBMITTED]: '#4AACDC',

  'Not started': '#B3B3B3',
  'View Only': '#B3B3B3',
  'In progress': '#2CCB6F',
  Training: '#2CCB6F',
  'In review': '#AD55FF',
  Available: '#2A58F6',
  Rejected: '#DA645D',
  Failed: '#F46057',
  Failure: '#F46057',
  'AI-anno': '#7DCC49',
  Submitted: '#4AACDC',
  Deploying: '#2CCB6F',
  Deployed: '#2A58F6',
  DeployFailure: '#F46057',
  DeployPending: '#B3B3B3',

  'common.notStarted.disciple': '#B3B3B3',
  'common.inProgress.hypopial': '#2CCB6F',
  'common.completed.boston': '#2A58F6',
} as const;
